class EventsFilters {
  constructor(eventTypes, events, flyers) {
    const today = new Date();
    this.flyers = flyers;
    this.eventTypes = eventTypes;
    this.events = events
      .filter((event) => new Date(event.start) >= today)
      .sort((a, b) => new Date(a.start) - new Date(b.start));
    this.selectedEventTypes = new Set();
    this.onFilterChangeCallbacks = [];
  }

  // Method to filter and return a copy of the events array based on selected event types
  filterEvents() {
    if (this.selectedEventTypes.size === 0) {
      return [...this.events]; // Return all events if no filters are selected
    }
    return this.events.filter((event) => this.selectedEventTypes.has(event.type));
  }

  // Method to handle the logic for selecting a single event type
  toggleEventType(eventType) {
    const checkboxes = document.querySelectorAll('.events-filters-form input[type="checkbox"]');

    checkboxes.forEach((checkbox) => {
      const label = checkbox.parentElement;
      if (checkbox.value === eventType) {
        checkbox.checked = true;
        label.classList.add('active');
      } else {
        checkbox.checked = false;
        label.classList.remove('active');
      }
    });

    const matchingFlyer =
      this.flyers.find((flyer) => {
        const handleize = (str) =>
          str
            .toString()
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9\-]/g, '');

        console.log('flyer.title (', handleize(flyer.title), ') vs eventType (', handleize(eventType), ')');

        return handleize(flyer.title).includes(handleize(eventType));
      }) ?? false;

    const flyerElement = document.querySelector('#events .events-container #filter-summary') ?? false;
    if (!!flyerElement) {
      flyerElement.innerHTML = ''; // Clear previous content
      flyerElement.classList.add('hidden');
    }

    if (matchingFlyer && !!matchingFlyer.summary) {
      const flyerSummaryContentContainer = document.createElement('div');
      flyerSummaryContentContainer.className = 'flyer-summary-content';
      const flyerSummaryContent = document.createRange().createContextualFragment(matchingFlyer.summary);
      flyerSummaryContentContainer.appendChild(flyerSummaryContent);
      flyerElement.appendChild(flyerSummaryContentContainer);

      const flyerSummaryActionContainer = document.createElement('div');
      flyerSummaryActionContainer.className = 'flyer-summary-action';
      const flyerButton = document.createElement('button');
      flyerButton.className = 'flyer-toggle';
      flyerButton.setAttribute('aria-label', `View flyer for ${matchingFlyer.title}`);
      flyerButton.setAttribute('data-flyer-id', matchingFlyer.title.replace(/\s+/g, '-').toLowerCase());
      flyerButton.classList.add('btn', 'kah-btn');
      flyerButton.innerHTML = `<span>${matchingFlyer.cta_text || 'View Flyer'}</span>`;
      flyerSummaryActionContainer.appendChild(flyerButton);
      flyerElement.appendChild(flyerSummaryActionContainer);

      flyerElement.classList.remove('hidden');
    } else {
      flyerElement.innerHTML = '';
      flyerElement.classList.add('hidden');
    }

    this.selectedEventTypes.clear();
    this.selectedEventTypes.add(eventType);
    this.notifyFilterChange();
  }

  // Method to handle the logic for selecting all event types
  toggleSelectAll(isChecked) {
    const checkboxes = document.querySelectorAll('.events-filters-form input[type="checkbox"]');
    this.selectedEventTypes.clear();

    const flyerSummaryElement = document.querySelector('#events .events-container #filter-summary');
    flyerSummaryElement.innerHTML = ''; // Clear previous content
    flyerSummaryElement.classList.add('hidden');

    checkboxes.forEach((checkbox) => {
      if (checkbox.value === 'select-all') {
        checkbox.checked = isChecked;
        checkbox.parentElement.classList.toggle('active', isChecked);
      } else {
        checkbox.checked = false;
        checkbox.parentElement.classList.remove('active');
      }
    });

    // Remove "filterEvent" URL parameter if all event types are selected
    if (isChecked) {
      const params = new URLSearchParams(window.location.search);
      params.delete('filterEvent');
      history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
    }

    const flyerElement = document.querySelector('#events #filter-summary') ?? false;
    if (!!flyerElement) {
      flyerElement.innerHTML = '';
      flyerElement.classList.add('hidden');
    }

    this.notifyFilterChange();
  }

  // Updated method to build the HTML of the filters and return it as a form of checkbox pills
  buildFiltersForm() {
    const form = document.createElement('form');
    form.classList.add('events-filters-form');

    // Add "Select All" option
    const selectAllLabel = document.createElement('label');
    selectAllLabel.classList.add('filter-pill');

    const selectAllCheckbox = document.createElement('input');
    selectAllCheckbox.type = 'checkbox';
    selectAllCheckbox.value = 'select-all';
    selectAllCheckbox.classList.add('visually-hidden');

    selectAllCheckbox.addEventListener('change', () => {
      this.toggleSelectAll(selectAllCheckbox.checked);
    });

    selectAllLabel.appendChild(selectAllCheckbox);
    selectAllLabel.appendChild(document.createTextNode('Select All'));
    form.appendChild(selectAllLabel);

    // Preselect "select All" on build
    selectAllCheckbox.checked = true;
    selectAllLabel.classList.add('active');

    // Add event type filters
    this.eventTypes.forEach((eventType, index) => {
      const label = document.createElement('label');
      label.classList.add('filter-pill');

      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.value = eventType;
      checkbox.classList.add('visually-hidden');

      // Store the change handler for later use
      checkbox._changeHandler = () => {
        this.toggleEventType(eventType);
      };
      checkbox.addEventListener('change', checkbox._changeHandler);

      label.appendChild(checkbox);
      label.appendChild(document.createTextNode(eventType));
      form.appendChild(label);
    });

    return form;
  }

  // Method to notify listeners when the filter changes
  notifyFilterChange() {
    const filteredEvents = this.filterEvents();
    this.onFilterChangeCallbacks.forEach((callback) => callback(filteredEvents));
  }

  // Method to allow other scripts to listen to filter changes
  onFilterChange(callback) {
    if (typeof callback === 'function') {
      this.onFilterChangeCallbacks.push(callback);
    }
  }

  // Method to render the filters form to a specified container
  render(selector) {
    const container = document.querySelector(selector);
    if (!container) {
      console.error(`Selector "${selector}" not found.`);
      return;
    }

    container.innerHTML = ''; // Clear any existing content
    container.appendChild(this.buildFiltersForm());
  }
}
